import NavigationTab from '../NavigationTab';
import NavigationFooterTab from '../NavigationFooterTab';
import styled from 'styled-components';
import { up } from 'styled-breakpoints';
import { useRouter } from 'next/router';
import NotificationModal from '../NotificationModal';
import { useEffect, useState } from 'react';
import API from '../../../API';
import { useCookies } from 'react-cookie';
import { useAppContext } from '../../../store';
import { navigateToLoginInNewTab } from '../../../API/router';
import { featureToggle } from '../../../constants/common';
import { TOKEN } from '../../../constants/common';
import GTM from '../../../GTM';
import { routes } from '../../../config/routes';
import { error } from 'console';

interface NavigationBarProps {
  activeMenu: number; // to highlight the current tab
  hasNotification?: boolean;
  currentRoute?: string;
  setEnableInsights?: Function;
  setShowPFMV2NavigationButton?: Function;
  onUserGuideClick?: Function;
  updateHasPortfolio?: Function;
  enableDisableDropDown?: boolean;
}

interface OtherDetailsProps {
  hasPortfolio: boolean;
  cutOffDetails: {
    liquid: string;
    others: string;
    liquidSwitch: string;
  };
  encryptedInvestmentIds: object;
  enableInsightNavigation: boolean;
  showPFMV2NavigationButton: boolean;
}
export interface NotificationsData {
  data?: {
    data: Array<Notification>;
  };
}

interface OtherDetailsData {
  data?: {
    data: OtherDetailsProps;
  };
}

export interface CartDetails {
  data?: {
    data:{
      investmentId: string;
      cartId:string;
      contents: Array<string>;
    }
  }
}

export default function NavigationBar(props: NavigationBarProps) {
  const { activeMenu, hasNotification, currentRoute, setEnableInsights, setShowPFMV2NavigationButton, onUserGuideClick, updateHasPortfolio, enableDisableDropDown } = props;
  const router = useRouter();
  const [openNotification, setOpenNotification] = useState(false);
  const [hideNotificationCount, setHideNotificationCount] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [isLoggedIn, setIsLoggedIn] = useState(undefined);
  const { state, setState } = useAppContext();
  const [hasPortfolio, setHasPortfolio] = useState(false);
  const [cookie] = useCookies();

  useEffect(() => {
    if (state.customerId) {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
    }
  }, [state, state.customerId]);

  useEffect(() => {
    if (isLoggedIn) {
      API.customer.getDetails().then((res: OtherDetailsData) => {
        const response = res?.data?.data;
        if (res && res?.data?.data?.hasPortfolio) {
          setHasPortfolio(true);
          updateHasPortfolio && updateHasPortfolio(true);
        }
        else{
          API.investments.getInvestmentIdsUrl()
          .then((res: any) => {
            if(res?.data?.data.length > 0){
              setHasPortfolio(true);
              updateHasPortfolio && updateHasPortfolio(true);
            }
          })
          .catch((err) => {
            console.error(err);
          });
        }
        setEnableInsights && setEnableInsights(response?.enableInsightNavigation);
        setShowPFMV2NavigationButton && setShowPFMV2NavigationButton(response?.showPFMV2NavigationButton);
        setState({
          ...state,
          liquidCutOffTiming: response?.cutOffDetails?.liquid,
          otherCutOffTiming: response?.cutOffDetails?.others,
          liquidSwitch: response?.cutOffDetails?.liquidSwitch,
          encryptedInvestmentIds: response?.encryptedInvestmentIds
        });
      });
      API.customer.getNotifications().then((res: NotificationsData) => {
        if (res && res?.data?.data) {
          setNotifications(res?.data?.data);
        }
      });

      API.cart.getCartDetails()
      .then((res: CartDetails) => {
         const schemeCount = res?.data?.data?.contents?.length;
         setState({ ...state, cartSchemeCount: schemeCount });
      });
    }
  }, [isLoggedIn]);

  const onNotificationClose = () => {
    setHideNotificationCount(false);
    setOpenNotification(false);
  };

  const navigationBarUsedInAndTriggerRelatedGAEvent = (currentRoute: string) => {
    // TODO: Add routes here if in case GA for other modules on notification is added
    switch (currentRoute) {
      case routes.PORTFOLIO.url:
        GTM.portfolio.onClickOfNotification();
        break;

      default:
        break;
    }
  };

  const onOpenNotification = () => {
    navigationBarUsedInAndTriggerRelatedGAEvent(currentRoute);
    setHideNotificationCount(true);
    setOpenNotification(true);
  };

  const onLoginToViewPortfolioButtonClick = () => {
    // If the customer has portfolio redirect him to portfolio page or else redirect him to MFLP
    navigateToLoginInNewTab(state.channelId);
  };
  return (
    <NavigationBarWrapper>
      {openNotification && <NotificationModal notifications={notifications} onClose={onNotificationClose} />}
      <NavigationTabWrapper>
        <NavigationTab
          hasPortfolio={hasPortfolio}
          activeMenu={activeMenu}
          hasNotificationIcon={hasNotification}
          onOpenNotification={onOpenNotification}
          notificationCount={notifications ? notifications.filter((str) => str.length > 0).length : undefined}
          hideNotificationCount={hideNotificationCount || !notifications}
          isLoggedIn={isLoggedIn}
          onLoginToViewPortfolioButtonClick={onLoginToViewPortfolioButtonClick}
          enableFAQ={featureToggle.FAQ}
          enableNotification={featureToggle.NOTIFICATION_ICON}
          onUserGuideClick={onUserGuideClick}
        />
      </NavigationTabWrapper>
      <NavigationFooterTabWrapper>
        <NavigationFooterTab
          hasPortfolio={hasPortfolio}
          activeMenu={activeMenu}
          hasNotificationIcon={hasNotification}
          onOpenNotification={onOpenNotification}
          notificationCount={notifications && notifications.filter((str) => str.length > 0).length}
          hideNotificationCountNumber={hideNotificationCount || (notifications && notifications.length === 0)}
          isLoggedIn={isLoggedIn}
          onLoginToViewPortfolioButtonClick={onLoginToViewPortfolioButtonClick}
          enableFAQ={featureToggle.FAQ}
          enableNotification={featureToggle.NOTIFICATION_ICON}
          onUserGuideClick={onUserGuideClick}
          enableDisableDropDown = {enableDisableDropDown}
        />
      </NavigationFooterTabWrapper>
    </NavigationBarWrapper>
  );
}

NavigationBar.defaultProps = {
  hasNotification: true,
};

const NavigationBarWrapper = styled.div`
  width: 100%;
  height: 100%;
  z-index: 9;
`;

const NavigationTabWrapper = styled.article`
  display: none;
  ${up('md')} {
    display: block;
    z-index: 1;
    border-bottom: 1px solid #d8d8d8;
    background-color: #f0f0f0;
  }
`;

const NavigationFooterTabWrapper = styled(NavigationBarWrapper)`
  display: block;
  position: relative;
  ${up('md')} {
    display: none;
  }
`;

export const navBarHeight = '61px';
